var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-md"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41675 5.33333C7.16159 5.33333 5.33341 7.1615 5.33341 9.41667C5.33341 11.6718 7.16159 13.5 9.41675 13.5C10.5169 13.5 11.5154 13.0649 12.2496 12.3575C12.265 12.3375 12.2818 12.3183 12.3001 12.3C12.3184 12.2817 12.3376 12.2649 12.3576 12.2496C13.065 11.5153 13.5001 10.5168 13.5001 9.41667C13.5001 7.1615 11.6719 5.33333 9.41675 5.33333ZM13.5187 12.6936C14.2371 11.7955 14.6667 10.6563 14.6667 9.41667C14.6667 6.51717 12.3162 4.16667 9.41675 4.16667C6.51725 4.16667 4.16675 6.51717 4.16675 9.41667C4.16675 12.3162 6.51725 14.6667 9.41675 14.6667C10.6563 14.6667 11.7956 14.2371 12.6937 13.5186L14.8376 15.6625C15.0654 15.8903 15.4348 15.8903 15.6626 15.6625C15.8904 15.4347 15.8904 15.0653 15.6626 14.8375L13.5187 12.6936Z",
    fill: "#1E1E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMd);
export default __webpack_public_path__ + "static/media/search-md.8bc656439ebd00ffaed5524358fa19c7.svg";
export { ForwardRef as ReactComponent };